import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EstadoDescuentosVC, ProyectoProductoVC, TipoTarificacionProyectoVc } from '../../model/pack.model';
import { FormGroup } from '@angular/forms';
import { CaFormFieldComponent, CaIcon } from '@global-front-components/ui/form-field';
import { CaButtonComponent } from '@global-front-components/ui/button';
import { PreguntaVentaCruzadaComponent } from '../pregunta-venta-cruzada/pregunta-venta-cruzada.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CaModalComponent, CaModalOverlayService, ModalConfig } from '@global-front-components/ui/modal-overlay';
import { ModalInformacionComponent } from '../modal-informacion/modal-informacion.component';
import { IsoCurrencyToSymbolPipe } from '../../util/iso-currency-to-symbols.pipe';

@Component({
	selector: 'app-proyecto-venta-cruzada',
	standalone: true,
	imports: [
		CommonModule,
		CaIcon,
		CaButtonComponent,
		CaFormFieldComponent,
		PreguntaVentaCruzadaComponent,
		TranslateModule,
		CaModalComponent, 
		IsoCurrencyToSymbolPipe
	],

	templateUrl: './proyecto-venta-cruzada.component.html',
	styleUrls: ['./proyecto-venta-cruzada.component.scss']
})
export class ProyectoVentaCruzadaComponent implements OnInit {
	@Input() productoVC: ProyectoProductoVC;
	@Input() form: FormGroup;
	@Input() estadoDescuentos: EstadoDescuentosVC = EstadoDescuentosVC.SIN_DESCUENTOS;
	EstadoDescuentosVC = EstadoDescuentosVC;
	TipoTarificacionProyectoVc = TipoTarificacionProyectoVc;
	modalConfig: ModalConfig;

	@Output() add = new EventEmitter<ProyectoProductoVC>();
	@Output() update = new EventEmitter<ProyectoProductoVC>();
	@Output() remove = new EventEmitter<ProyectoProductoVC>();
	@Output() select = new EventEmitter<ProyectoProductoVC>();
	@Output() simular = new EventEmitter<ProyectoProductoVC>();

	constructor(
		private translateService: TranslateService,
		private _modalService: CaModalOverlayService
	) { }

	ngOnInit(): void {
		this.modalConfig = {
			windowDrag: true,
			backdropClick: true,
			isBodyScrollable: true,
			closable: true,
			minimizable: false,
			size: 'xl'
		}				
	}

	anadirProductoVC(): void {
		if (this.productoVC.proyectoVC === null){
			this.add.emit(this.productoVC);
		} else {
			this.select.emit(this.productoVC);
		}
	}

	modificarProductoVC(): void {
		this.update.emit(this.productoVC);
	}

	eliminarProductoVC(): void {
		this.toggleCampos();
		this.remove.emit(this.productoVC);
	}

	seleccionarProyectoVC(): void {
		this.select.emit(this.productoVC);
	}

	tarificarProductoVC() {
		this.simular.emit(this.productoVC);
	}

	toggleCampos() {
		if (this.productoVC?.configProyecto?.camposProducto?.length) {
			this.productoVC.configProyecto.camposProducto = [];
			this.form?.reset();
		}
	}

	mostrarModalInfoDescuentos(descuento: number) {
		const textoTraducido = this.translateService.instant(
			'PACKS.DESCUENTOS.INFORMACION.TXT_INFO',
			{ descuento }
		);
		const tituloModal = this.translateService.instant('PACKS.DESCUENTOS.INFORMACION.TITULO_MODAL');

		const modalConfig  = this.modalConfig;
		modalConfig.data = { textoInfo: textoTraducido };
		modalConfig.title = tituloModal;
		this._modalService.open(ModalInformacionComponent, modalConfig);
	}

	mostrarModalInfoCoberturas(url: string) {
		const tituloModal = this.translateService.instant('PACKS.CONSULTAR_COBERTURAS');
		const modalConfig  = this.modalConfig;
		modalConfig.data= { urlImagen: url}
		modalConfig.title = tituloModal;
		modalConfig.size = 'xl';
		this._modalService.open(ModalInformacionComponent, modalConfig);
	}

	getPeriodicidadProducto(pvc: ProyectoProductoVC){
		const campo = pvc?.proyectoVC?.camposProducto?.find(c => c.codCampo === 'DESC_COD_FRACC');
  		return (campo?.valor ?? campo?.valorDefecto ?? '') as string;
	}

	public hayCamposVisibles(pvc: ProyectoProductoVC = this.productoVC): boolean {
		const campos = pvc?.configProyecto?.camposProducto;
		return Array.isArray(campos) && campos.some(c => c?.visible === true);
	}

}
